export default __webpack_public_path__ + "static/media/project-trillo.ce477e24.jpg";